import * as React from "react";
import { useTranslation } from "react-i18next";
import { useEffect, useState, useCallback, useContext } from "react";
import styled, { css } from "styled-components";
import { MenuItem } from "components/bootstrap";
import DashboardPageContext from "views/components/contexts/DashboardPageContext";
import useViewsDispatch from "views/stores/useViewsDispatch";
import { duplicateQuery } from "views/logic/slices/viewSlice";
import QueryActionDropdown from "./QueryActionDropdown";
const Container = styled.div`
  display: flex;
  align-items: center;
`;
const TitleWrap = styled.span(
  ({ $active }) => css`
    padding-right: ${$active ? "6px" : "0"};
  `
);
const QueryTitle = ({
  active,
  allowsClosing = true,
  id,
  onRemove,
  openEditModal,
  openCopyToDashboardModal,
  title
}) => {
  const { t } = useTranslation("search");
  const [titleValue, setTitleValue] = useState(title);
  const { setDashboardPage } = useContext(DashboardPageContext);
  const dispatch = useViewsDispatch();
  useEffect(() => {
    setTitleValue(title);
  }, [title]);
  const _onDuplicate = useCallback(
    () => dispatch(duplicateQuery(id)).then((queryId) => setDashboardPage(queryId)),
    [dispatch, id, setDashboardPage]
  );
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(TitleWrap, { "aria-label": titleValue, $active: active, "data-testid": "query-tab", "data-active-query-tab": active }, titleValue), active && /* @__PURE__ */ React.createElement(QueryActionDropdown, null, /* @__PURE__ */ React.createElement(MenuItem, { onSelect: () => openEditModal(titleValue) }, t("query_title.edit_title")), /* @__PURE__ */ React.createElement(MenuItem, { onSelect: _onDuplicate }, t("query_title.duplicate")), /* @__PURE__ */ React.createElement(MenuItem, { onSelect: () => openCopyToDashboardModal(true) }, t("query_title.copy_to_dashboard")), /* @__PURE__ */ React.createElement(MenuItem, { divider: true }), /* @__PURE__ */ React.createElement(MenuItem, { onSelect: onRemove, disabled: !allowsClosing }, t("common:actions.delete"))));
};
export default QueryTitle;
